import React,{Suspense} from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import Loading from './pages/Loading';
import './assets/css/style.css'
import {Routes, Route} from 'react-router-dom'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import WhatsAppButton from './components/common/WhatsAppButton';
import LanguageSwitcher from './components/common/LanguageSwitcher';

const Home = React.lazy(() => import('./pages/Home'))
const PrivacyPolicy = React.lazy(() => import('./pages/PrivacyPolicy'))
const Error = React.lazy(() => import('./pages/Error404'))


function App() {
  return (
    <>
      <Suspense fallback={<Loading/>}>
          <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="*" element={<Error />} />
              
          </Routes>

          <WhatsAppButton />
          <LanguageSwitcher />

          <ToastContainer
              position="bottom-left"
              autoClose={5000}
          />
      </Suspense>
    </>
  );
}

export default App;
